// src/features/owner/components/DateRangePicker.tsx — simple range select (7/30/90 days).
import styled from 'styled-components';

const Select = styled.select`
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  color: ${({ theme }) => theme.color.textPrimary};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 7px 11px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: -2px;
  }
`;

const OPTIONS = [
  { d: 7, l: 'Last 7 days' },
  { d: 30, l: 'Last 30 days' },
  { d: 90, l: 'Last 90 days' },
];

export interface DateRangePickerProps {
  valueDays: number;
  onChange: (days: number) => void;
}

export function DateRangePicker({ valueDays, onChange }: DateRangePickerProps) {
  return (
    <Select
      aria-label="Date range"
      value={valueDays}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {OPTIONS.map((o) => (
        <option key={o.d} value={o.d}>
          {o.l}
        </option>
      ))}
    </Select>
  );
}
